export const LOGIN_ROUTE = '/login';
export const ROOT_ROUTE = '/';

// For the Component Demo page
export const DEMO_ROUTE = "/demo";

// For the HIC app
export const HIC_DASHBOARD_ROUTE = "/hic";
export const HIC_REPORT_ROUTE = "/hic/report";
export const HIC_ARTICLE_ROUTE_BASE = "/hic/article/";
export const HIC_ARTICLE_ROUTE = HIC_ARTICLE_ROUTE_BASE + ":articleId";
export const HIC_ARTICLE_PREVIEW_ROUTE = HIC_ARTICLE_ROUTE + "/preview";
export const HIC_NEW_ARTICLE_ROUTE = "/hic/create-article";

// For the Outcomes app
export const OUTCOMES_APP_BASE_ROUTE = "/outcomes";
export const SECTIONS_DASHBOARD_ROUTE = "/outcomes/sections";
export const OUTCOMES_SECTION_ROUTE_BASE = "/outcomes/sections/";
export const OUTCOMES_SECTION_ROUTE = OUTCOMES_SECTION_ROUTE_BASE + ":sectionId";
export const OUTCOMES_CREATE_SECTION_ROUTE = OUTCOMES_SECTION_ROUTE_BASE + "create-section";
export const OUTCOMES_SECTION_PREVIEW_ROUTE = OUTCOMES_SECTION_ROUTE + '/preview';

export const ELEMENTS_DASHBOARD_ROUTE = "/outcomes/elements";
export const OUTCOMES_ELEMENT_ROUTE_BASE = "/outcomes/elements/";
export const OUTCOMES_ELEMENT_ROUTE = OUTCOMES_ELEMENT_ROUTE_BASE + ":elementId";
export const OUTCOMES_NEW_ELEMENT_ROUTE = "/outcomes/elements/create-element";

export const METRICS_DASHBOARD_ROUTE = "/outcomes/metrics";
export const OUTCOMES_METRIC_ROUTE_BASE = "/outcomes/metrics/";
export const OUTCOMES_METRIC_ROUTE = OUTCOMES_METRIC_ROUTE_BASE + ":metricId";
export const OUTCOMES_METRIC_PREVIEW_ROUTE = OUTCOMES_METRIC_ROUTE + '/preview';
export const OUTCOMES_NEW_METRIC_ROUTE = "/outcomes/metrics/create-metric";

// For the Clinical Trials app
export const CLINICAL_TRIALS_DASHBOARD_ROUTE = "/clinicaltrials";
export const CLINICAL_TRIALS_TRIAL_ROUTE_BASE = "/clinicaltrials/trial/";
export const CLINICAL_TRIALS_TRIAL_ROUTE = CLINICAL_TRIALS_TRIAL_ROUTE_BASE + ":trialId";
export const CLINICAL_TRIALS_NEW_TRIAL_ROUTE = "/clinicaltrials/create-trial";
export const CLINICAL_TRIALS_TRIAL_PREVIEW_ROUTE = CLINICAL_TRIALS_TRIAL_ROUTE + "/preview";

// For User Management across all apps.
export const USER_MANAGEMENT_ROUTE = "/users";

// For Cardiac Rehab Calculator
export const CRC_ROUTE = "/";

// Keep this list in "priority" order.  i.e. If a user who has identical
// roles in both HIC and Outcomes should be routed to HIC by default, make
// sure HIC comes before Outcomes in this list.
export const AppDataForPath = [
  { pathPattern: DEMO_ROUTE, appName: "Components Demo", ideasUrl: "https://via.ideas.aha.io/ideas" },
  { pathPattern: HIC_DASHBOARD_ROUTE, appName: "HIC", permissionsName: "hic", ideasUrl: "https://via-hic.ideas.aha.io/ideas" },
  { pathPattern: OUTCOMES_APP_BASE_ROUTE, appName: "Outcomes", permissionsName: "outcomes", ideasUrl: "https://via-outcomes.ideas.aha.io/ideas" },
  { pathPattern: CLINICAL_TRIALS_DASHBOARD_ROUTE, appName: "Clinical Trials", permissionsName: "clinicaltrials", ideasUrl: "https://via-clinicaltrials.ideas.aha.io/ideas" },
  { pathPattern: USER_MANAGEMENT_ROUTE, appName: "Manage Users", ideasUrl: "https://via.ideas.aha.io/ideas" },
  { pathPattern: CRC_ROUTE, appName: "Cardinal Rehab Calculator", permissionsName: "crc", ideasUrl: "https://via.ideas.aha.io/ideas" }
];



// WEBPACK FOOTER //
// ./src/constants/routes.js